import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Notification |||| Notificationss',
      fields: {
        email: 'Email',
      }
    }
  }
}